import axios from "../Helpers/Axios";
import Request from "../Helpers/Request";
import Cookies from "js-cookie";
const addUser=async(data)=>{
    return await Request("admin/createUser",data);
}
const addUserService={
    addUser,
    }
export default addUserService